<template>
  <div class="navbar-text">
    nicetomeetor
  </div>
</template>

<script>
export default {
  name: "Logo",
}
</script>

<style scoped>
.navbar-text {
  color: #26ade4;
  font-size: 32px;
  font-weight: 700;
  overflow: hidden;
  white-space: nowrap;
  letter-spacing: .15em;
  animation: typing 0.5s steps(13, end)
}

@keyframes typing {
  from { width: 0 }
  to { width: 100% }
}
</style>
